// Flexar: как выглядит фокус с клавиатуры — одно решение на все примитивы.
//
// Рецепт лежал строкой в каждом компоненте, и его копии уже начали расходиться: у кнопки было
// кольцо с отступом, у поля ввода — без, у переключателя темы — ещё и без снятия системной
// рамки. Пока это литералы, следующая правка фокуса снова разъедется по четырём файлам.
//
// Цвет берётся из токена `--accent-primary` (`src/theme/tokens.ts`), здесь — только толщина,
// состояние и отступ.

/** Кольцо фокуса: системная рамка снята, вместо неё 1px акцентного цвета. */
export const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-accent-primary';

/** Зазор между элементом и кольцом — для того, что стоит на цветной поверхности. */
export const FOCUS_RING_OFFSET =
  'focus-visible:ring-offset-2 focus-visible:ring-offset-background';
